import * as React from 'react';
import { cn } from '@/utils';

import { Label } from '@/components/ui/Label';
import { Switch } from '@/components/ui/Switch';

type NewSwitchProps = {
  id?: string;
  checked?: boolean;
  defaultChecked?: boolean;
  onCheckedChange?: (checked: boolean) => void;
  disabled?: boolean;
  label?: React.ReactNode;
  showLabel?: boolean;
  // class overrides
  className?: string; // wrapper
  switchClassName?: string;
  thumbClassName?: string;
  labelClassName?: string;
  // accessibility
  ariaLabel?: string;
};

export function NewSwitch({
  id,
  checked,
  defaultChecked,
  onCheckedChange,
  disabled = false,
  label = 'Colored switch',
  showLabel = true,
  className,
  switchClassName,
  thumbClassName,
  labelClassName,
  ariaLabel,
}: NewSwitchProps) {
  return (
    <div
      id={id}
      className={cn(
        'inline-flex items-center gap-2 [--primary:var(hsl(--primary))] [--ring:var(hsl(--primary))]',
        className
      )}
    >
      <Switch
        className={switchClassName}
        {...(typeof checked !== 'undefined' ? { checked } : {})}
        {...(typeof defaultChecked !== 'undefined' ? { defaultChecked } : {})}
        onCheckedChange={onCheckedChange}
        disabled={disabled}
        aria-label={ariaLabel}
      />
      {showLabel && (
        <Label className={cn('text-base font-normal text-tundora', labelClassName)}>{label}</Label>
      )}
    </div>
  );
}
